module.exports = __webpack_public_path__ + "static/lottery-pointer.63eb5a59.png";